var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapParadaSecundario(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "q6daun5pna",
    width: "135.7%",
    height: "135.7%",
    x: "-17.9%",
    y: "-17.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "5r8k9r7zzc"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.274510 0 0 0 0 0.235294 0 0 0 0 0.196078 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "5p3li1683b",
    cx: 21,
    cy: 21,
    r: 21
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#q6daun5pna)",
    xlinkHref: "#5p3li1683b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#5p3li1683b"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#5r8k9r7zzc)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M1.263 2.309c.045.155.171.283.34.348.17.064.365.057.528-.019l.486-.227v5.07c0 .286.27.519.601.519H4.4C4.731 8 5 7.767 5 7.48V.52C5 .233 4.73 0 4.399 0h-.9c-.167 0-.332.036-.479.104L1.317.89c-.243.113-.366.355-.299.586l.245.832zM14 7.488v-.882c0-.283-.252-.512-.564-.512h-1.838c1.29-1.17 2.22-2.231 2.22-3.56 0-1.22-.909-2.534-2.904-2.534-.927 0-1.818.291-2.507.82l-.04.03c-.192.148-.254.394-.15.602l.378.76c.073.147.216.253.388.29.171.035.352-.004.487-.106l.07-.053c.215-.163.654-.437 1.17-.437.595 0 .838.215.838.736-.009.779-.763 1.556-2.569 3.117l-.808.713C8.061 6.568 8 6.7 8 6.839v.649c0 .283.252.512.564.512h4.872c.312 0 .564-.23.564-.512zM16.258 7.43l.046.027c.432.25 1.296.543 2.31.543C20.94 8 22 6.673 22 5.44c0-.73-.375-1.37-1-1.792.457-.398.71-.917.71-1.497C21.71 1.115 20.837 0 18.916 0c-1.028 0-1.908.335-2.35.621l-.042.027c-.204.133-.285.368-.2.578L16.64 2c.06.149.197.264.368.311.171.047.357.021.503-.07l.076-.048c.263-.167.715-.334 1.131-.334.678 0 .678.304.678.435 0 .454-.767.557-1.037.557h-.637c-.316 0-.572.226-.572.505v.798c0 .278.256.504.572.504h.637c.304 0 1.295.056 1.304.773.002.085-.014.302-.202.47-.22.198-.588.24-.858.24-.542 0-1.087-.197-1.322-.33l-.074-.042c-.147-.083-.33-.102-.494-.052-.166.05-.296.164-.354.31l-.325.814c-.088.219.005.462.225.59zM5.495 17.247H5.07V13.52c0-.287-.227-.52-.505-.52H3.499c-.165 0-.32.083-.414.222L.091 17.629c-.06.087-.091.19-.091.297v.694c0 .286.226.52.505.52h2.582v1.34c0 .287.227.52.506.52h.972c.278 0 .505-.233.505-.52v-1.34h.425c.279 0 .505-.234.505-.52v-.853c0-.287-.226-.52-.505-.52zm-2.408 0h-.519l.52-.741v.741zM22.498 21.78l-3.31-3.31c-.035-.035-.072-.067-.11-.099.949-1.938.62-4.347-.989-5.956-2.024-2.024-5.318-2.024-7.342 0-2.025 2.024-2.025 5.318 0 7.343 1.012 1.012 2.341 1.518 3.67 1.518.784 0 1.567-.177 2.286-.529.031.038.064.074.099.11l3.31 3.31c.329.329.76.493 1.193.493.431 0 .863-.164 1.193-.494.659-.659.659-1.727 0-2.386zm-10.16-3.613c-1.148-1.147-1.148-3.014 0-4.161.573-.573 1.326-.86 2.08-.86.753 0 1.507.286 2.08.86 1.147 1.147 1.147 3.014 0 4.16-1.147 1.148-3.013 1.148-4.16 0z",
    transform: "translate(10 9)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapParadaSecundario);
export default __webpack_public_path__ + "static/media/map-parada-secundario.aa1fe690.svg";
export { ForwardRef as ReactComponent };